import React from 'react';

const Footer = () => {
  const dat = new Date();
  return (
    <div className="footer">
      <div className="copyright">
        <p>Copyright © {dat.getFullYear()} Designed &amp; Developed by Medsky</p>
      </div>
    </div>
  );
};

export default Footer;
